import { Injectable } from '@angular/core';
import { DefaultService } from '@common/references/default.service';
import { environment } from '@environments/environment';
import urlJoin from 'url-join';

@Injectable({ providedIn: 'root' })

export class SmartMeterService extends DefaultService<any>{
  backendName = 'smart-meters';
  getUrl(): string {
    return urlJoin(environment.apiUrl, this.backendName);
  }
}
